import { Component, OnInit, Output, EventEmitter, ViewChild, Sanitizer, ElementRef, ChangeDetectorRef, Inject, AfterViewInit, Renderer2 } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { request } from 'http';
import { Router, ActivatedRoute } from '@angular/router';
//import { RequestMetadata, PagedResult } from '../../../../lib/ng-crud-table';
import { MatTableDataSource, fadeInContent } from '@angular/material';
import { DataSource } from '@angular/cdk/table';
import { MatDialog, MatDialogConfig, PageEvent, MatPaginator } from '@angular/material';
import { Row } from 'lib/ng-data-table';
import { SelectItem, Keys } from 'lib/common';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { NgSwitchCase, DOCUMENT } from '@angular/common';
import { validateBasis } from '@angular/flex-layout';
import { AppComponent } from 'src/app/app.component';
import { SystemSettingConfig } from 'src/app/shared/models/SystemSettingConfig';
import { SystemSettingsService } from 'src/app/shared/services/system-settings/system-settings.service';
import { transcode } from 'buffer';


@Component({
  selector: 'app-explore-options',
  templateUrl: './explore-options.component.html',
  styleUrls: ['./explore-options.component.scss']
})
export class ExploreOptionsComponent implements OnInit {

  title: string = "ExpolreOptions";
  staticScreen = true;
  @Output() childTitleEvent = new EventEmitter();
  baseUrl: string;
  //@Input() activePanel;
  isPanelActive_1: boolean = false;
  isPanelActive_2: boolean = false;
  isPanelActive_3: boolean = false;
  isPanelActive_4: boolean = false;
  isPanelActive_5: boolean = false;
  isPanelActive_6: boolean = false;
  isPanelActive_7: boolean = false;
  isPanelActive_8: boolean = false;
  isPanelActive_F1: boolean = false;
  isPanelActive_F2: boolean = false;
  imgSrc: string;
  imageDetails: any;
  showImageModal: boolean = false;
  modalWidth: number;
  modalHeight: number;
  constructor(private elementRef: ElementRef, private renderer: Renderer2, private el: ElementRef, private http: HttpClient, private cdr: ChangeDetectorRef, private logservice: SystemSettingsService, private dialog: MatDialog, @Inject(DOCUMENT) private _document: Document, private router: Router, private route: ActivatedRoute) {
    this.baseUrl = environment.urlAddress + '/api/';
    //this.router.navigate([{ outlets: { filterPopup: null, configPopup: null } }]);

  }


  ngOnInit() {
    this.renderer.addClass(this.el.nativeElement, 'custom-class');
    this.parentEvent();
    this.AddOverlayBackGround();
  }

  AddOverlayBackGround() {
    // Create overlay element
    const overlay = this.renderer.createElement('div');

    // Add overlay class and append to body
    this.renderer.addClass(overlay, 'overlayBackGround');
    this.renderer.appendChild(document.body, overlay);
  }

  parentEvent() {
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }

  close() {
    // Remove overlay element from body
    const overlay = document.querySelector('.overlayBackGround');
    if (overlay) {
      overlay.parentNode.removeChild(overlay);
    }


    this.router.navigate([{ outlets: { popupExploreOptions: null } }]);       
  }


  openTab(tabID: string, tabContentID): void {
    debugger;
    /////  TO Remove all active class from left panel
    const divButtons = this.elementRef.nativeElement.querySelector('.tab');
    if (divButtons) {
      const buttons = divButtons.querySelectorAll('button');

      buttons.forEach((button: HTMLButtonElement) => {
        // Remove any existing class from each button
        button.classList.remove('active');
      });
    }
    ///// To hide all div content from right panel except the selected one
    const divTabContnet = this.elementRef.nativeElement.querySelector('.DivTabContent');
    if (divTabContnet) {
      const divList = divTabContnet.querySelectorAll('div');

      divList.forEach((div: HTMLDivElement) => {
        // Remove any existing class from each button
        div.classList.remove('tabcontentShow');
        div.classList.add('tabcontentHide');
      });
    }

    ////// To make specific button active from left panel and div visible from right panel
    const elementTab = this.elementRef.nativeElement.querySelector(`#${tabID}`);
    const elementTabContent = this.elementRef.nativeElement.querySelector(`#${tabContentID}`);
    if (elementTab) {
      elementTab.classList.add('active');
      elementTabContent.classList.remove('tabcontentHide');
      elementTabContent.classList.add('tabcontentShow');
      if (tabContentID == "GoogleMapContent" || tabContentID == "CustomReportContent" || tabContentID == "FilterContent" || tabContentID == "ReportSchedulingContent") {
        const innerDivList = elementTabContent.querySelectorAll('div');
        innerDivList.forEach((div: HTMLDivElement) => {
          // Remove any existing class from each button
          div.classList.remove('tabcontentHide');
          div.classList.add('tabcontentShow');
        });
      }

    }

  }

  OpenHelpPdf(targetPageNumber) {

    let pdfFilePath = '/Webviewer/assets/DowloadedScripts/WebViewer-UM.pdf?v=6.4.20';  //// '/Webviewer/assets/images/ITS/ITSHelp.pdf?v=6.4.20';

    const pdfViewerUrl = `${pdfFilePath}#page=${targetPageNumber}`;  /// to open particular page number of pdf

    const windowFeatures = 'menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes,height = ' + screen.height * .66 + ',width=' + screen.width * .66;
    // Open the popup window
    //const popupWindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    const popupWindow = window.open('', '_blank', windowFeatures);

    popupWindow.document.open();
    popupWindow.document.write(`
				<html>
					<head>
						<title>Webviewer User Module</title>
						
            <body onload=""><iframe src="${pdfViewerUrl}" width="100%" height="100%"></iframe></body>
          </head>
        </html>
      `);
    ///// <body onload=""><iframe src="${pdfFilePath}" width="100%" height="100%"></iframe></body>
    ///<body onload=""><iframe src="${pdfViewerUrl}" width="100%" height="100%"></iframe></body> /// to open partiular page of pdf
    popupWindow.document.close();

  }

  // Toggle the active state when the panel is expanded or collapsed
  togglePanelState(panelName: string): void {
    
    if (panelName == "panel1") {
      this.isPanelActive_1 = !this.isPanelActive_1;
    }
    else if (panelName == "panel2") {
      this.isPanelActive_2 = !this.isPanelActive_2;
    }
    else if (panelName == "panel3") {
      this.isPanelActive_3 = !this.isPanelActive_3;
    }
    else if (panelName == "panel4") {
      this.isPanelActive_4 = !this.isPanelActive_4;
    }
    else if (panelName == "crpanel1") {
      this.isPanelActive_5 = !this.isPanelActive_5;
    }
    else if (panelName == "crpanel2") {
      this.isPanelActive_6 = !this.isPanelActive_6;
    }
    else if (panelName == "crpanel3") {
      this.isPanelActive_7 = !this.isPanelActive_7;
    }
    else if (panelName == "crpanel4") {
      this.isPanelActive_8 = !this.isPanelActive_8;
    }
    else if (panelName == "FilterPanel1") {
      this.isPanelActive_F1 = !this.isPanelActive_F1;
    }
    else if (panelName == "FilterPanel2") {
      this.isPanelActive_F2 = !this.isPanelActive_F2;
    }

  }

  onClick(event) {
    debugger;
    const imgElem = event.target;
    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;
    this.imgSrc = srcAttr.nodeValue;
    this.modalWidth = event.target.naturalWidth;
    this.modalHeight = event.target.naturalHeight;

    this.showImageModal = true;
    this.imageDetails = this.imgSrc;

  }
  onCloseModal(event) {

  }


}
